import { awards as awardsSettings } from '@settings';
import { CtaButton } from '@tkww/orion-web-ds-action';
import { PageContainer } from '@tkww/orion-web-ds-page-layout';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Element, scroller } from 'react-scroll';
import { withinDateRange } from '../../../../utils/withinDateRange';
import AwardType from './AwardType';
import Category from './category';
import Icon from './icon';
import Location from './location';
import Styles from './styles.scss';

export default class SearchComponent extends PureComponent {
	static propTypes = {
		awardType: PropTypes.object.isRequired,
		categories: PropTypes.array.isRequired,
		category: PropTypes.object.isRequired,
		fetchVendors: PropTypes.func.isRequired,
		initialLocation: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
		setAwardType: PropTypes.func.isRequired,
		setCategory: PropTypes.func.isRequired,
		setLocation: PropTypes.func.isRequired,
		anonymousId: PropTypes.string,
		userId: PropTypes.string,
	};

	fetchVendors = () => {
		this.props
			.fetchVendors(
				this.props.category,
				this.props.location,
				this.props.awardType,
				this.props.anonymousId,
				this.props.userId,
			)
			.then(() => {
				scroller.scrollTo('searchResultsHeader', {
					duration: 800,
					delay: 0,
					smooth: 'linear',
				});
			});
	};

	render() {
		const {
			initialLocation,
			setLocation,
			location,
			categories,
			category,
			setCategory,
			awardType,
			setAwardType,
		} = this.props;
		const isWithinDateRange = withinDateRange({
			startDate: awardsSettings.startDate,
			endDate: awardsSettings.endDate,
		});

		return (
			<div className={Styles.bowWrapper}>
				<div className={isWithinDateRange ? Styles.bow2024 : Styles.bow2023}>
					<PageContainer>
						<GridRow>
							<GridColumn md="2" />
							<GridColumn md="8">
								<div className={Styles.searchBoxContainer}>
									<div className={Styles.searchBoxForm}>
										<div className={Styles.searchBox}>
											<GridRow>
												<GridColumn md="12" lg="12">
													<h3 className={Styles.bowTitle}>
														Best of Weddings Winners
													</h3>
												</GridColumn>
											</GridRow>
											<Location
												initialLocation={initialLocation}
												setLocation={setLocation}
												location={location}
											/>
											<Category
												categories={categories}
												category={category}
												setCategory={setCategory}
											/>
											<AwardType
												awardType={awardType}
												setAwardType={setAwardType}
											/>
											<GridRow>
												<GridColumn
													md="6"
													lg="6"
													className={Styles.searchButton}
												>
													<CtaButton
														size="lg"
														styleType="primary"
														onClick={this.fetchVendors}
													>
														Search
													</CtaButton>
												</GridColumn>
											</GridRow>
										</div>
									</div>
									<Icon awardType={awardType} />
								</div>
							</GridColumn>
							<GridColumn md="2" />
						</GridRow>
					</PageContainer>
					<div className={Styles.photoCredit}>
						<span>
							{isWithinDateRange
								? 'Photo Credit: Jana Williams Photography'
								: 'Photo Credit: Page Jones Photography'}
						</span>
					</div>
				</div>
				<Element name="searchResultsHeader" />
			</div>
		);
	}
}
